import { SliderManager } from "./components/SliderManager.js";

SliderManager.use();
